import { BriefcaseIcon, BuildingOffice2Icon, EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { CiFacebook } from "react-icons/ci";


export function ContactAndSchedule() {
    return <>
    <div className='flex flex-row flex-wrap space-x-2 text-sm w-full items-center'>
        <EnvelopeIcon className="h-3 w-3"/><p>Email Address:</p>
        <p>totalsolarph@gmail.com</p>
    </div>
    <div className='flex flex-row flex-wrap space-x-2 text-sm w-full items-center'>
        <CiFacebook className="h-3 w-3"/><p>Facebook Page:</p>
        <p><a href="https://www.facebook.com/profile.php?id=100085341354458" target="_blank" className="font-extrabold hover:underline"><span className="text-white-500">Total Solar Installation</span></a></p>
        
    </div>

    <div className='py-6'>
        <div className='text-sm flex items-center space-x-2'><BriefcaseIcon className="h-3 w-3"/><p>Business Hours</p></div>
        <p className='text-sm'>Monday - Friday; 9:00 am - 5:00 pm</p>
    </div>
    <div className=''>
        <div className='text-sm flex items-center space-x-2'><BuildingOffice2Icon className="h-3 w-3"/><p>Office Address</p></div>
        <p className='text-sm'>RM 208 and 210, Deiparine Bldg, Cebu South Rd, Talisay Cebu across Robinson Town Center, Talisay, Philippines</p>
    </div>


    
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d245.37055022134072!2d123.8428895433569!3d10.26732042225763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x33a99c551e692a63%3A0xed90c1c07549fcec!2sDeiparine%20Building%2C%20Cebu%20S%20Rd%2C%20Talisay%2C%20Cebu!5e0!3m2!1sen!2sph!4v1693156620048!5m2!1sen!2sph" 
            className={'w-full h-[300px] border-0 my-8'} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
    
    </>
}